﻿<template>
    <h2>BOOKING REFERENCE #{{Get_Booking_Reference()}}</h2>
    <p>Agent Reference: <b>{{Get_Agent_Reference()}}</b></p>
    <p>Consultant: <b>{{Get_Consultant()}}</b></p>
    <p>Booking Date: <b>{{Get_Booking_Date()}}</b></p>
</template>

<script lang="ts" src="./header.ts"></script>